<template>
    <v-card outlined>
        <v-card-title>Einen Moment bitte, Du wirst in Kürze weitergeleitet...</v-card-title>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <p>
                        Für die weitere Eingabe deiner Daten wirst du in Kürze in unser Portal weitergeleitet. Deine bereits
                        eingegebenen Daten werden dort übernommen.
                    </p>
                    <p>
                        Solltest du nicht innerhalb von 3 Sekunden weitergeleitet werden, klick bitte <a @click.stop="clickLink">hier</a>.
                    </p>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import Config from "@/constants/Config";

export default {
    name: 'RedirectionPage',
    props: ['dataId'],
    computed: {
        portalLink()
        {
            return Config.PORTAL_URL + '/redirected/flight/' + this.dataId;
        }
    },
    methods: {
        clickLink()
        {
            window.location.href = this.portalLink;
        }
    }
}
</script>

<style scoped>

</style>